import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ breakpoints, spacing, palette }: Theme) => ({
  footer: {
    backgroundColor: palette.background.default,
    position: 'fixed',
    width: '100%',
    bottom: 0,
    zIndex: 1,
    borderTop: `1px solid ${palette.divider}`,
  },
  containerFooter: {
    margin: spacing(2, 'auto'),
    // maxWidth: breakpoints.values.md,
    maxWidth: '990px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  buttonNext: {
    // Make the button full width on mobile.
    [breakpoints.down('sm')]: {
      flex: 1,
    },
  },
}));
